import { Slot } from "@radix-ui/react-slot";
import { ComponentPropsWithoutRef, use, useRef } from "react";
import { byShortcut } from "../../helpers/predicate";
import { useKeyboard } from "../../hooks/useKeyboard";
import { Button } from "../Button/Button";
import { PopoverContext } from "./contexts/PopoverContext";

type PopoverTriggerProps = (
  | ({ asChild: true } & Omit<ComponentPropsWithoutRef<typeof Slot>, "color">)
  | ({
      asChild?: false;
    } & ComponentPropsWithoutRef<typeof Button>)
) & {
  delay?: number;
};

export function PopoverTrigger({
  asChild = false,
  delay = 0,
  ...props
}: PopoverTriggerProps) {
  const timeoutRef = useRef<number | null>(null);
  const { open, popoverId, setOpen, triggerRef } = use(PopoverContext);
  const Component = asChild ? Slot : Button;

  useKeyboard(byShortcut("Escape"), () => setOpen(false), {
    cleanup: () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    },
  });

  return (
    <Component
      aria-describedby={open ? popoverId : undefined}
      onClick={() => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(() => setOpen(true), delay);
      }}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ref={triggerRef as React.Ref<any>}
      tabIndex={0}
      {...props}
    />
  );
}
